import { ROAST_CONFIG } from '../config.js';

export default {
    getChargingStations: function(minimumPower) {
        return axios.get(ROAST_CONFIG.API_URL + '/charging-stations', {
            params: {
                minimumPower: minimumPower
            }
        });
    },

    getChargingStation: function(slug) {
        return axios.get(ROAST_CONFIG.API_URL + '/charging-stations/' + slug);
    },

    getChargingStationOperators: function() {
        return axios.get(ROAST_CONFIG.API_URL + '/charging-stations/operators');
    }
}
